import { LocalPhone } from "@mui/icons-material";
import { Box } from "@mui/material";
import { FC } from "react";

import config from "../../../utils/config";
import styles from "./LoginFooter.module.scss";

const LoginFooter: FC = () => {
    const navigateToTerms = ()=> window.open(config.terms, '_blank', 'noreferrer');
    
    return (
        <Box sx={{ marginTop: "2.25rem", textAlign: "center" }}>
            <p className={`mb-10 ${styles.forMore}`}>

                <LocalPhone color={"error"} className={`${styles.iconPhone}`} />
                For more information, call us at{" "}

                <a className={styles.phoneNumber} href="tel:0641-9764325">
                    0641-9764325
                </a>

            </p>
            <p className="font-size-14 cursor-pointer" onClick={navigateToTerms}>*Terms and conditions apply</p>
        </Box>
    )
}

export default LoginFooter